
namespace RioERP.Products {
    export class CategoryColumns {
        static columnsKey = 'Products.Category';
    }
}